import axios from '@/lib/axios-instance';
import { APIUrlGenerator } from '@/lib/helper';

import { API_ROUTES } from '@/constant/routes';

export async function getTour(currentUrl: string, previewId: string | null = null) {
  try {
    const {
      data: { payload },
    }: { data: { payload: any } } = await axios.get(
      APIUrlGenerator(API_ROUTES.GET_TOUR(currentUrl, previewId)),
    );
    return payload;
  } catch (error) {
    throw error;
  }
}

export async function doneTour(id: string) {
  try {
    const {
      data: { payload },
    }: { data: { payload: any } } = await axios.post(
      APIUrlGenerator(API_ROUTES.DONE_TOUR(id)),
    );
    return payload;
  } catch (error) {
    throw error;
  }
}
